// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"416":"dab12963","422":"99f113f2"}[chunkId] + ".css";
};